import { ChangeEvent, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getQueryParams } from 'components/AddCatalogList/helpers';
import TextInput from 'components/textInput/textInput';
import Checkbox from 'library/checkbox/checkbox';
import { insertOrRemove } from 'utils/utility/utils';
import { useAllDesignerDetail } from '../helper';
import { FilterTypes, IGetEachOption } from '../type';
import * as Styles from './styles';

interface IDesignerFilterProps {
  onClose(): void;
  onFilterChange(param: Partial<Record<FilterTypes, Array<string>>>): void;
}

const DesignerFilter = ({ onClose, onFilterChange }: IDesignerFilterProps) => {
  const designerData = useAllDesignerDetail();
  const { search } = useLocation();
  const currentQueryParams = getQueryParams(search);
  const [createdBySearch, setCreatedBySearch] = useState('');
  const [list, setCreatedByList] =
    useState<Array<IGetEachOption>>(designerData);
  const [selectedCheckbox, setSelectedCheckbox] = useState<Array<string>>(
    currentQueryParams?.designer__in ?? []
  );

  function handleSearchChange(event: ChangeEvent<HTMLInputElement>) {
    let value = event.target.value;
    setCreatedBySearch(value);
    setCreatedByList(matchQuery(value, designerData));
  }

  function matchQuery(value: string, options: Array<any>) {
    const newCategories: Array<IGetEachOption> = [];
    options.forEach(eachOption => {
      if (eachOption.name.toLowerCase().startsWith(value.toLowerCase())) {
        newCategories.push(eachOption);
      }
    });

    return newCategories;
  }

  function handleCategoryCheck(value: string) {
    const updatedSelectedOptions = insertOrRemove(selectedCheckbox, value);
    setSelectedCheckbox(updatedSelectedOptions);
  }

  function handleApplyFilter() {
    onFilterChange({ designer__in: selectedCheckbox });
  }

  function handleClearOption() {
    onFilterChange({ designer__in: [] });
  }

  return (
    <Styles.DesignerFilterContainer className="pos-a full-width">
      <Styles.DesignerHeader className="spread">
        <Styles.DesignerHeaderText>Designers</Styles.DesignerHeaderText>
        <Styles.DesignerHeaderClearAll
          className="cursor-pointer"
          onClick={handleClearOption}
        >
          Clear
        </Styles.DesignerHeaderClearAll>
      </Styles.DesignerHeader>
      <Styles.DesignerContainer>
        <TextInput
          placeholder="Search Name"
          onChange={handleSearchChange}
          onClear={() => null}
          value={createdBySearch}
          listItemSearchBoxClass="list-item-search-box-class"
          showCrossButton={false}
        />
      </Styles.DesignerContainer>
      <Styles.DesignerFilterResults className="has-y-scroll">
        {list?.map(item => (
          <Styles.FilterOption key={item.id}>
            <Checkbox
              item={{
                value: item.id,
              }}
              label={item.name}
              onChange={() => handleCategoryCheck(item.id)}
              checked={selectedCheckbox.includes(item.id)}
            />
          </Styles.FilterOption>
        ))}
      </Styles.DesignerFilterResults>
      <Styles.BottomTabButtons className="spread">
        <Styles.ClearButton onClick={onClose}>Cancel</Styles.ClearButton>
        <Styles.ApplyButton
          className="cursor-pointer"
          onClick={handleApplyFilter}
        >
          Apply
        </Styles.ApplyButton>
      </Styles.BottomTabButtons>
    </Styles.DesignerFilterContainer>
  );
};

export default DesignerFilter;
